import React from "react";
import { useHistory } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const PLACES = ["A place to work", "A place to stay", "A place to eat", "Something to experience"];

export default function PlayMakeMore() {
  const history = useHistory();

  return (
    <section className="relative overflow-hidden lg:h-[568px]">
      <img
        src="/figma-assets/play/travellers.jpg"
        alt="Travellers exploring a city"
        className="absolute inset-0 size-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[rgba(10,10,10,0.9)] via-[rgba(10,10,10,0.6)] to-[rgba(10,10,10,0.2)]" />

      <div className="relative mx-auto max-w-[1440px] px-[16px] py-20 sm:px-8">
        <div className="max-w-[576px]">
          <p className="text-[14px] font-semibold uppercase leading-5 tracking-[1.4px] text-[#017bef]">
            For Travellers
          </p>
          <h2 className="pt-[12px] text-[36px] font-bold leading-[1.2] tracking-[-1.2px] text-white sm:text-[48px] sm:leading-[48px]">
            Make More of Where You Are
          </h2>
          <p className="pt-[20px] text-[18px] leading-[29.25px] text-white">
            Wherever you're travelling, SPACIA helps you discover a place to work, somewhere to stay, somewhere to eat
            and something to experience — all in one place.
          </p>
          <ul className="grid grid-cols-1 gap-[12px] pt-8 sm:grid-cols-2">
            {PLACES.map(place => (
              <li key={place} className="flex items-center gap-2 text-[14px] leading-5 text-white">
                <span className="size-1.5 shrink-0 rounded-full bg-[#017bef]" />
                {place}
              </li>
            ))}
          </ul>
          <button
            type="button"
            onClick={() => history.push("/workspaces-search?type=play&categoryId=3")}
            className="mt-10 inline-flex items-center gap-2 rounded-full bg-[#017bef] px-7 py-3.5 text-[14px] font-bold leading-5 text-white drop-shadow-[0_4px_8px_rgba(1,123,239,0.3)] transition-colors hover:bg-[#0062c0]"
          >
            Explore SPACIA
            <ArrowRight className="size-[15px]" />
          </button>
        </div>
      </div>
    </section>
  );
}
